import React from 'react';
import PropTypes from 'prop-types'; // eslint-disable-line import/no-extraneous-dependencies

import InfoIcon from './InfoIcon';
import FileIcon from './FileIcon';
import ArrowIcon from './ArrowIcon';
import CloseIcon from './CloseIcon';
import InterrogationIcon from './InterrogationIcon';

const CustomIcon = ({ iconName }) => {
  switch (iconName) {
    case 'accordion-arrow-down':
      return <ArrowIcon />;
    case 'close':
      return <CloseIcon />;
    case 'info':
      return <InfoIcon />;
    case 'interrogation':
      return <InterrogationIcon />;
    case 'file':
      return <FileIcon />;
    default:
      return null;
  }
};

CustomIcon.propTypes = {
  iconName: PropTypes.string,
};

CustomIcon.defaultProps = {
  iconName: '',
};

export default CustomIcon;
